import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import ColoredMarker from './ColoredMarker';
//import HoverPopper from "./HoverPopper";
export interface StatusProps {
  currentStatus?: string;
  alert?: boolean;
  className?: string;
}

const Status = ({ ...props }: StatusProps) => {
  const popover = (
    <Tooltip id="diagnosis-not-up-to-date" className="popover">
      Les diagnostics ne sont pas à jour pour ce bien :
      <Button className="popoverBtn" href="#" size="sm">
        Commander
      </Button>
    </Tooltip>
  );

  return (
    <>
      <span className="position-relative rowBtn d-block">
        <ColoredMarker className={props.className} color={props.currentStatus === 'Aucune' ? '#000D5B55' : '#000D5B'}>
          {props.currentStatus}
          {props.alert === true ? (
            <OverlayTrigger trigger="focus" overlay={popover} placement="bottom">
              <button className="marker-badge d-flex justify-content-center align-items-center">!</button>
            </OverlayTrigger>
          ) : (
            <></>
          )}
        </ColoredMarker>
      </span>
    </>
  );
};

export default Status;
